import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import img from '../../../images/chevron-right_black.svg';
import { LinkStyles } from '../../Core/Link/styles';

export const Wrapper = styled.div`
  margin: 20px 0;
`;

export const BladeButton = styled.button.attrs(() => ({
  type: 'button',
}))`
  display: flex;
  align-items: center;
  width: 100%;
  line-height: 24px;
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.normal')};
  text-align: left;

  &::after {
    content: '';
    height: 13px;
    width: 8px;
    background-image: url(${img});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    margin-left: 0.5rem;
    transition: all 0.3s ease;
  }

  &.application-blade {
    ${LinkStyles}
  }

  &:hover {
    text-decoration: underline;
    &::after {
      transform: translateX(4px);
      transition: all 0.3s ease;
    }
  }
`;

export const Paragraph = styled.p`
  margin: 1.25rem 2rem;
  font-size: 16px;
  font-weight: ${themeGet('fontWeights.normal')};
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
`;

export const Ulist = styled.ul`
  padding: 0 20px;

  p {
    margin: 0;
  }
`;

export const Olist = styled.ol`
  padding: 0 20px;

  p {
    margin: 0;
  }
`;

export const CTAWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 20px;
`;

export const ParagraphContainer = styled.div`
  position: relative;

  .sr-only {
    clip: rect(0px, 0px, 0px, 0px);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

export const StyledSup = styled.sup`
  position: absolute;
  top: 0;
  left: 0;
  min-width: 2rem;
  min-height: 1em;
  padding: 8px 4px 0 0;
  text-align: right;
`;

export const StyledSpan = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  min-width: 2rem;
  min-height: 1em;
  padding: 0 4px 0 0;
  text-align: right;
`;
